// Firebase configuration and services
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
// For development: Connect to Firebase emulators
import { connectFunctionsEmulator } from 'firebase/functions';
import { connectFirestoreEmulator } from 'firebase/firestore';

// Environment detection
const APP_ENV = process.env.REACT_APP_ENV || 'development';
const isProduction = APP_ENV === 'production';
const isDevelopment = APP_ENV === 'development' || window.location.hostname === 'localhost';

// Firebase config - same project for both environments
// Data isolation is handled by collection prefixes or separate projects
const firebaseConfig = {
  apiKey: "AIzaSyBJeqauUWY5W_7ZLVZlLBxpCuhViIj9qvA",
  authDomain: "consulting-87038.firebaseapp.com",
  projectId: "consulting-87038",
  storageBucket: "consulting-87038.appspot.com",
  messagingSenderId: "281032231562",
  appId: "1:281032231562:web:3e4b3f52d5f8d3726afb73"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

// Export environment info for use in other components
export const environment = {
  name: APP_ENV,
  isProduction,
  isDevelopment,
  label: isProduction ? 'PRODUCTION' : 'SANDBOX/TEST',
};

// Log environment on startup
console.log(`🌍 Environment: ${environment.label} (${APP_ENV})`);
if (!isProduction) {
  console.log('💡 PayPal is in SANDBOX mode - no real money will be charged');
}

// Connect to emulators (only in development)
let emulatorsConnected = false;

if (!emulatorsConnected && isDevelopment) {
  try {
    connectFunctionsEmulator(functions, 'localhost', 5555);
    console.log('🔧 Connected to Functions emulator at localhost:5555');
    
    connectFirestoreEmulator(db, 'localhost', 8080);
    console.log('🔧 Connected to Firestore emulator at localhost:8080');
    
    emulatorsConnected = true;
    console.log('✅ Firebase emulators connected successfully');
  } catch (error) {
    console.warn('⚠️ Could not connect to Firebase emulators:', error);
    console.warn('Make sure emulators are running: firebase emulators:start');
  }
}

export default app;
